import { Heading } from "@/components";
import { AccessConfig } from "./AccessConfig";

const AccessMgmt = () => {
  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Access Management" />
        </div>
      </div>

      {/* Note: Do not modify this component directly.
        To add or remove permissions, update permissionMatrixTitles in src/lib/utils.tsx
        —all other settings will update automatically.  */}
      <AccessConfig />
    </div>
  );
};

export default AccessMgmt;
